if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/serviceworker.js')
            .then((reg) => {
                // console.log('service worker installed, scope is: ', reg.scope);
            })
            .catch((err) => {
                // console.error('Error: \n', err);
            });
    });
}

var Core = {
    Auth: {
        init: function () {
            $('.auth-component-login').focus();
            $('.auth-component-btn').click(function () {
                $('.auth-component-error').slideUp();
                $('.auth-component-success').slideUp();
                Core.Auth.checkCredentials();
            });

            $('.auth-component-login, .auth-component-password').keyup(function (e) {
                if (e.keyCode == 13 || e.charCode == 13) {
                    $('.auth-component-error').slideUp();
                    Core.Auth.checkCredentials();
                }
            });

            $('.auth-component-forgot').click(function () {
                $('.auth-component-error').slideUp();
                $('.main-login').addClass('main-hidden');
                $('.main-forgot').removeClass('main-hidden');
                $('.auth-component-forgot-login').focus();
                $('.auth-component-forgot-login').val('').removeAttr('disabled');
                $('.auth-component-forgot-email').val('').removeAttr('disabled');
                (<any>$('.auth-component-forgot-btn')).loading('stop');
            });

            $('.auth-component-forgot-back').click(function () {
                $('.auth-component-error').slideUp();
                $('.main-forgot').addClass('main-hidden');
                $('.main-forgot-code').addClass('main-hidden');
                $('.main-forgot-changepassword').addClass('main-hidden');
                $('.main-login').removeClass('main-hidden');
                $('.auth-component-login').focus();
            });

            $('.auth-component-forgot-code').click(function () {
                $('.auth-component-error').slideUp();
                $('.main-forgot').addClass('main-hidden');
                $('.main-forgot-code').removeClass('main-hidden');
                $('.auth-component-forgot-token').focus();
            });

            $('.auth-component-forgot-login, .auth-component-forgot-email').keyup(function (e) {
                if (e.keyCode == 13 || e.charCode == 13) {
                    $('.auth-component-error').slideUp();
                    Core.Auth.ForgotPassword();
                }
            });

            $('.auth-component-forgot-btn').click(function () {
                $('.auth-component-error').slideUp();
                Core.Auth.ForgotPassword();
            });

            $('#btn-forgot-code').click(function () {
                $('.auth-component-error').slideUp();
                Core.Auth.ResetPassword();
            });

            $('.auth-component-changepassword-back').click(function () {
                grecaptcha.reset();
                $('.auth-component-error').slideUp();
                $('.main-changepassword').addClass('main-hidden');
                $('.main-login').removeClass('main-hidden');
                $('.main-forgot').addClass('main-hidden');
                $('.main-forgot-code').addClass('main-hidden');
                $('.auth-component-login').focus();
            });

            $('.auth-component-changepassword-showpass').click(function () {
                if (!$(this).attr('show')) {
                    $('.auth-component-error').slideUp();
                    $('.auth-component-newpassword').attr('type', 'text');
                    $(this).html('Esconder Senha');
                    $(this).attr('show', 1);
                } else {
                    $('.auth-component-error').slideUp();
                    $('.auth-component-newpassword').attr('type', 'password');
                    $(this).html('Mostrar Senha');
                    $(this).removeAttr('show');
                }
            });
        },

        checkCredentials: function () {
            var params = {
                login: <any>$('.auth-component-login').val(),
                password: <any>$('.auth-component-password').val(),
                save: $('.auth-component-save').is(':checked') ? 1 : 0,
                env: $('.auth-component-btn').attr('env'),
                captcha: grecaptcha.getResponse(),
            };

            if (params.login.length < 4) {
                $('.auth-component-login').focus();
                $('.auth-component-login-icon').css('color', 'red');
                return false;
            }

            if (params.password.length < 6) {
                $('.auth-component-password').focus();
                $('.auth-component-password-icon').css('color', 'red');
                return false;
            }

            Core.CallAuth(
                'CheckCredentials',
                params,
                'json',
                function () {
                    (<any>$('.auth-component-btn')).loading('start');
                },
                function (r: any) {
                    if (r.response) {
                        if (r.response == true) {
                            Core.ReloadPage();
                        } else if (r.response.changepassword == true) {
                            Core.Auth.ChangePassword(r);
                        }
                    } else {
                        grecaptcha.reset();
                        (<any>$('.auth-component-btn')).loading('stop');
                        $('.auth-component-error').html("<i class='mdi mdi-alert'></i> Dados não conferem!").slideDown();
                    }
                }
            );
        },

        ForgotPassword: function () {
            var params = {
                login: (<any>$('.auth-component-forgot-login')).val(),
                email: (<any>$('.auth-component-forgot-email')).val(),
            };

            if (params.login.length > 4 || params.email.length > 5) {
                $('.auth-component-forgot-login').attr('disabled', 'disabled');
                $('.auth-component-forgot-email').attr('disabled', 'disabled');
                (<any>$('.auth-component-forgot-btn')).loading('start');

                Core.CallAuth('Forgot', params, 'json', null, function (r: any) {
                    if (r.response) {
                        $('.main-forgot').addClass('main-hidden');
                        $('.main-forgot-code').removeClass('main-hidden');
                        $('.auth-component-forgot-token').focus();
                    } else {
                        $('.auth-component-forgot-login').removeAttr('disabled');
                        $('.auth-component-forgot-email').removeAttr('disabled');
                        (<any>$('.auth-component-forgot-btn')).loading('stop');
                        $('.auth-component-error').html("<i class='mdi mdi-alert'></i> Usuário não encontrado!").slideDown();
                    }
                });
            } else {
                $('.auth-component-forgot-login').focus();
            }
        },

        ResetPassword: function () {
            var params = {
                token: (<any>$('.auth-component-forgot-token')).val(),
            };

            if (params.token.length == 6) {
                (<any>$('.auth-component-forgot-code-btn')).loading('start');
                Core.CallAuth('Reset', params, 'json', null, function (r: any) {
                    if (r.response && r.response.success && r.response.newpass) {
                        let html = `<i class='mdi mdi-checkbox-marked'></i> 
                                    Senha alterada com sucesso!
                                    <br/>
                                    Sua nova senha é: ${r.response.newpass}`;

                        (<any>$('.auth-component-forgot-code-btn')).loading('stop');
                        $('.auth-component-changepassword-back').click();
                        $('.auth-component-success').html(html).slideDown();
                    } else {
                        (<any>$('.auth-component-forgot-code-btn')).loading('stop');
                        $('.auth-component-error').html("<i class='mdi mdi-alert'></i> Código inválido!").slideDown();
                    }
                });
            }
        },

        ChangePassword: function (r: any) {
            $('.main-changepassword').removeClass('main-hidden');
            $('.main-login').addClass('main-hidden');
            $('.auth-component-newpassword').focus();
            (<any>$('.auth-component-btn')).loading('stop');

            $('#btn-changepassword').unbind('click');
            $('#btn-changepassword').click(function () {
                Core.Auth.TryChangePassword(r.response);
            });
        },

        TryChangePassword: function (r: any) {
            var pass1: any = $('.auth-component-newpassword').val();
            if (pass1.length > 5) {
                var pass2 = $('.auth-component-newpassword2').val();
                if (pass1 == pass2) {
                    (<any>$('#btn-changepassword')).loading('start');
                    let params = {
                        action: 'systemusuarios/try_update_password',
                        user: r.user,
                        newpassword: pass1,
                        save: $('.auth-component-save').is(':checked') ? 1 : 0,
                    };

                    Core.CallJSON(params, function (re: any) {
                        if (re.response == true) {
                            $('.auth-component-newpassword').val('');
                            $('.auth-component-newpassword2').val('');
                            $('.auth-component-password').val('');
                            $('.auth-component-changepassword-back').click();
                            $('.auth-component-login-alert').show();
                        } else if (re.error) {
                            (<any>$('#btn-changepassword')).loading('stop');
                            $('.auth-component-error').html(re.error).slideDown();
                        }
                    });
                } else {
                    $('.auth-component-error').html("<i class='mdi mdi-alert'></i> Senhas devem ser iguais!").slideDown();
                }
            } else {
                $('.auth-component-error').html("<i class='mdi mdi-alert'></i> Mínimo 06 caracteres!").slideDown();
            }
        },

        Logout: function () {
            Core.CallAuth('Logout', null, 'json', null, function () {
                location.reload();
            });
        },
    },

    Actioner: {
        count: 0,

        init: function () {
            $('.actioner-component[fn]').each(function () {
                var fn = $(this).attr('fn');

                if (typeof fn !== 'undefined') {
                    $(this).removeAttr('fn');

                    var id = 'actioner-' + Core.Actioner.count;
                    $(this).attr('id', id);

                    // Attach this
                    fn = fn.replace('({', "({aid:'" + id + "',");
                    $(this).click(function () {
                        eval(fn);
                    });

                    Core.Actioner.count++;
                }
            });
        },
    },

    CallAuth: function (fn: any, params: any, format: any, callinit: any, callback: any) {
        format = typeof format !== 'undefined' ? format : 'json'; // ACCEPT JSON || HTML

        var obj = {
            fn: fn,
            params: params,
            format: format,
        };

        if (typeof callinit === 'function') {
            callinit();
        }

        $.post(
            '/P5fw/auth',
            obj,
            function (r) {
                if (typeof callback == 'function') {
                    callback(r);
                }
            },
            format
        );
    },

    CallJSON: function (params: any, callback: any = null) {
        $.post(
            '/P5fw/acmanager',
            params,
            function (r) {
                if (typeof callback === 'function') {
                    callback(r);
                }
            },
            'json'
        );
    },

    ReloadPage: function () {
        location.reload();
    },

    Serialize: function (obj: any) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }
        return str.join('&');
    },

    // WinManager: {
    //     _windows: [],
    //     current: null,
    //     zindex: 99,
    //     count: 1,
    //     cnt: '#core-content',
    //     tabhead: '#core-content-tabhead',
    //     beep: new Audio('/public/sounds/beep-08b.mp3'),
    //     save: true,

    //     //Open : function(aid, action, size, from, params, forcereload, resize, page, save)
    //     Open: function (wparams) {
    //         /*
    // 	* All Params:
    // 	- aid : "string com ícone e titulo";
    // 	- action : "string, ação do sistema";
    // 	- size : Tamanhos padrão de janela: 1,2,3,4,5 e 'full';
    // 	- customsize : { width: int, height: int}, neste case sobrepoe o parametro size;
    // 	- from : int (id da Window que origina, assim ao fechar dá focus automatico nesta window);
    // 	- params : Array de variaveis que serão enviadas para action;
    // 	- forcereload : Caso a Window estiver aberta, faz reload da action com o novos parâmetros passados;
    // 	- resize : Permite fazer resize da Window.
    // 	- page : Em caso de paginação;
    // 	- save : Por padrão é TRUE, ou seja essa janela é salva no usuário e quando ele logar novamente ela abre automatico.
    // 	*/
    //         var dfparams = {
    //             size: 3,
    //             forcereload: false,
    //             resize: true,
    //             save: true,
    //         };

    //         var settings = $.extend(dfparams, wparams);

    //         // verifica se já está aberta:
    //         var w = $(".window-component[action='" + settings.action + "']");
    //         if (w.length) {
    //             // Já existe
    //             const wid = w.attr('wid');

    //             const _window = Core.WinManager.GetByWid(wid);

    //             // verifica se action é editar, caso sim faz reload com novos parâmetros;
    //             var d = settings.action.split('_');
    //             if (d[1] == 'editar' || settings.forcereload) {
    //                 var title = document.getElementById(settings.aid) != null ? $('#' + settings.aid).html() : settings.aid;
    //                 $('#window-component-title-' + wid).html(title);
    //                 _window.title = title;
    //                 _window.params = settings.params;
    //                 this.LoadAction(_window);
    //             }

    //             if (w.attr('minimized') == '1') {
    //                 this.Restore(_window);
    //             } else if (_window.id != this.current.id) {
    //                 this.SetFocus(_window);
    //             }
    //         } else {
    //             wparams.title = document.getElementById(settings.aid) != null ? $('#' + settings.aid).html() : settings.aid;
    //             if (settings.title) wparams.title = settings.title;
    //             this.Create(wparams);

    //             this.TabSlider();
    //         }
    //     },

    //     //Create : function(title, action, size, from, params, resize, page, save)
    //     Create: function (wparams) {
    //         var dfparams = {
    //             forcereload: false,
    //             resize: true,
    //             page: 1,
    //             save: true,
    //         };

    //         var settings = $.extend(dfparams, wparams);
    //         var _window = {
    //             title: settings.title,
    //             id: 'window-component-' + this.count,
    //             wid: this.count,
    //             action: settings.action,
    //             from: settings.from,
    //             params: settings.params,
    //             page: settings.page,
    //         };

    //         var w = $("<div id='" + _window.id + "' tabindex='" + _window.wid + "' wid='" + _window.wid + "' class='window-component' action='" + settings.action + "'></div>");

    //         // Header Tab
    //         var wh = $("<div class='window-component-header' id='window-component-header-" + _window.wid + "'></div>");
    //         var wh_title = $("<div class='window-component-title' id='window-component-title-" + _window.wid + "' dow'>" + _window.title + '</div>');
    //         var wh_control = $("<div class='window-component-controls'></div>");

    //         var btn_close = $("<div class='window-component-control-btn mdi mdi-close'></div>");
    //         var btn_refresh = $("<div class='window-component-control-btn mdi mdi-reload'></div>");

    //         btn_close.click(function () {
    //             Core.WinManager.Close(_window);
    //         });

    //         btn_refresh.click(function () {
    //             Core.WinManager.ReloadAction(_window);
    //         });

    //         wh_control.append(btn_refresh);
    //         wh_control.append(btn_close);

    //         wh.append(wh_title);
    //         wh.append(wh_control);

    //         wh.attr('page', _window.page);

    //         wh.click(function () {
    //             if ($(this).hasClass('unfocus')) Core.WinManager.SetFocus(_window);
    //         });

    //         $(this.tabhead).append(wh);

    //         // Content
    //         const wc = $("<div id='window-component-content-" + _window.wid + "' class='window-component-content'></div>");

    //         w.append(wc);

    //         $(this.cnt).append(w);
    //         $(this.cnt).addClass('window-component-loader');

    //         this.SetFocus(_window, false); // save false on Create
    //         this.LoadAction(_window, null, settings.save);

    //         this._windows.push(_window);
    //         this.UnFocusAll(_window.wid);

    //         this.count++;
    //     },

    //     TabSlider: function () {
    //         // Verifica tabhead slider:
    //         var hw = $('.core-head').width();
    //         var thw = $('#core-content-tabhead').width();
    //         if (thw > hw) {
    //             $('.core-content-tabcontrols').show();
    //             var diff = hw - thw;
    //             diff = diff - 6;
    //             $('#core-content-tabhead').css('margin-left', diff + 'px');
    //         } else {
    //             $('.core-content-tabcontrols').hide();
    //             $('#core-content-tabhead').css('margin-left', '0px');
    //         }
    //     },

    //     Reopen: function () {
    //         if ($('#core-suw').length > 0) {
    //             var hash: any = $('#core-suw').val();
    //             $('#core-suw').remove();
    //             if (hash.length > 0) {
    //                 try {
    //                     var _ws: any = JSON.parse(hash);
    //                 } catch (e) {
    //                     var _ws: any = '';
    //                 }

    //                 if (_ws.length > 0) {
    //                     _.each(_ws, function (_w) {
    //                         _w.save = false;
    //                         Core.WinManager.Open(_w);
    //                     });
    //                 } else {
    //                     // Open Home
    //                     $(".actioner-component[ref='home']").click();
    //                 }
    //             }
    //         }

    //         if ($('#core-current').length > 0) {
    //             var current: any = $('#core-current').val();
    //             if (parseFloat(current) > 0) Core.WinManager.SetFocus(Core.WinManager.GetByWid(current), false);
    //         }
    //     },

    //     SetFocus: function (_window: any, save: any = true) {
    //         if (typeof _window != 'undefined') {
    //             var save = typeof save != 'undefined' ? save : true; // default true

    //             var w = $('#' + _window.id);
    //             w.show();

    //             var wh = $('#window-component-header-' + _window.wid);
    //             wh.removeClass('unfocus');
    //             this.UnFocusAll(_window.wid);

    //             this.current = _window;

    //             if (save) {
    //                 Core.WinManager.SaveWindows();
    //             }
    //         }
    //     },

    //     Close: function (_window: any, callback: any = null) {
    //         if (typeof _window == 'undefined') return true;

    //         if (typeof _window === 'number') _window = this.GetByWid(_window);

    //         var w = $('#' + _window.id);
    //         var wh = $('#window-component-header-' + _window.wid);

    //         w.remove();
    //         wh.remove();
    //         this._windows.splice(this._windows.indexOf(_window), 1);

    //         // from FK
    //         if (_window.params && _window.params.fromfk) {
    //             Core.CrudManager.UpdateFK(_window);
    //         }

    //         if (!_window.from) {
    //             // verifica se existe outra e seta focus;
    //             var last = this._windows.slice(-1).pop();
    //             if (typeof last !== 'undefined') this.SetFocus(last);
    //             else {
    //                 // Reset counter
    //                 this.count = 1;
    //                 Core.WinManager.SaveWindows(); // Save
    //             }
    //         } else {
    //             var _origin = Core.WinManager.GetByWid(_window.from);
    //             Core.WinManager.SetFocus(_origin);
    //         }

    //         if (typeof callback === 'function') callback();

    //         if (typeof _window.onClose === 'function') _window.onClose();

    //         this.TabSlider();
    //     },

    //     CloseAll: function () {
    //         this._windows = [];
    //         this.count = 1;
    //         $('.window-component, .core-component-toolbar-icon').remove();
    //         this.SaveWindows();
    //     },

    //     UnFocusAll: function (wid) {
    //         if (this._windows.length > 0)
    //             _.each(this._windows, function (_w) {
    //                 if (_w.wid != wid) {
    //                     var wh = $('#window-component-header-' + _w.wid);
    //                     var wc = $('#window-component-' + _w.wid);

    //                     if (!wh.hasClass('unfocus')) {
    //                         wh.addClass('unfocus');
    //                         wc.hide();
    //                     }
    //                 }
    //             });
    //     },

    //     LoadAction: function (_window, callback, save) {
    //         var save = typeof save != 'undefined' ? save : true; // default true
    //         var content: any = $('#window-component-content-' + _window.wid);
    //         if (content.attr('busy') != 1) {
    //             var orderfield = _window.orderfield;
    //             var order = _window.order;
    //             content.attr('busy', 1);
    //             content.addClass('window-component-loader');
    //             var data = {
    //                 action: _window.action,
    //                 page: _window.page,
    //                 wid: _window.wid,
    //                 orderfield: orderfield,
    //                 order: order,
    //                 params: _window.params,
    //                 filters: _window.filters,
    //             };

    //             $.post('/P5fw/acmanager', data, function (r) {
    //                 $(Core.WinManager.cnt).removeClass('window-component-loader');
    //                 content.html(r).removeClass('window-component-loader').animate({ scrollTop: 0 }, 200);
    //                 content.removeAttr('busy');

    //                 // Inicializa controllers de grid (caso houver)
    //                 Core.GridManager.init(_window.wid);

    //                 // Inicializa controllers de grid (caso houver)
    //                 Core.CrudManager.init(_window.wid);

    //                 // Inicializa controllers de album (caso houver)
    //                 Core.AlbumManager.init(_window.wid);

    //                 if (typeof callback === 'function') callback();

    //                 if (save) Core.WinManager.SaveWindows();
    //             });
    //         }
    //     },

    //     SaveWindows: function () {
    //         var w = JSON.stringify(Core.WinManager._windows);
    //         var c = typeof this.current === 'object' ? this.current.wid : null;
    //         Core.CallJSON({ action: 'systemusuarios_savewindows', hash: w, current: c });
    //     },

    //     ReloadAction: function (_window: any, callback: any = null) {
    //         if (typeof _window === 'number') {
    //             _window = this.GetByWid(_window);
    //         }
    //         // set Loader content
    //         var content = $('#window-component-content-' + _window.wid);
    //         if (content.attr('busy') != '1') {
    //             $(Core.WinManager.cnt).addClass('window-component-loader');
    //             content.html('');
    //             this.LoadAction(_window, callback, false);
    //         }
    //     },

    //     MaskContent: function (wid) {
    //         var content = $('#window-component-content-' + wid);
    //         var mask = $("<div class='window-component-mask' id='window-component-mask-" + wid + "'></div>");

    //         mask.css({ width: content.width(), height: content.height() });
    //         content.prepend(mask);
    //     },

    //     Dialog: function (wid: any, options: any, callback: any) {
    //         var dfoptions = {
    //             title: 'Atencão',
    //             kind: 'success',
    //             showinput: true,
    //             inputvalue: '',
    //             inputkind: 'text',
    //             inputstyle: null,
    //             inputmaxl: 255,
    //             inputminl: 0,
    //             inputnome: 'campo',
    //             showtext: null,
    //             btnsize: 'xs',
    //             custombtns: [],
    //             btnoklabel: 'OK',
    //             inputmask: null,
    //             placeholder: null,
    //         };

    //         var settings = $.extend(dfoptions, options);

    //         // Abre Mascara
    //         this.MaskContent(wid);

    //         var content = $('#window-component-content-' + wid);
    //         var _window = $('#window-component-' + wid);

    //         var dialog = $("<div class='window-component-dialog wcd-" + settings.kind + "' id='window-component-dialog-" + wid + "'></div>");
    //         var dialog_head = $("<div class='window-component-dialog-header'>" + settings.title + '</div>');
    //         var dialog_controls = $("<div class='window-component-controls'></div>");
    //         var control_close = $("<div class='mdi mdi-close window-component-control-btn'></div>");

    //         dialog_controls.append(control_close);
    //         dialog_head.append(dialog_controls);

    //         control_close.click(function () {
    //             Core.WinManager.CloseDialog(wid);
    //         });

    //         var _content = $("<div class='window-component-dialog-content'></div>");

    //         if (settings.showtext) {
    //             var text = $("<span style='font: normal 14px arial;'>" + settings.showtext + '</span>');
    //             _content.append(text);
    //         }

    //         if (settings.showinput) {
    //             var _input: any = $("<input type='text' class='input input-sm window-component-dialog-input' id='window-component-dialog-input-" + wid + "' maxlength='" + settings.inputmaxl + "' value='" + settings.inputvalue + "'/>");
    //             if (settings.inputstyle) _input.attr('style', settings.inputstyle);

    //             _content.append(_input);

    //             switch (settings.inputkind) {
    //                 case 'date':
    //                     _input.addClass('size2');
    //                     var options: any = {
    //                         format: 'dd/mm/yyyy',
    //                         autoclose: true,
    //                         todayBtn: 'linked',
    //                         todayHighlight: true,
    //                         minView: 2,
    //                     };
    //                     _input.datetimepicker(options);
    //                     if (settings.inputvalue == 'hoje') _input.val(new Date().date_format('%d/%m/%Y'));
    //                     break;

    //                 case 'int':
    //                     _input.addClass('size2');
    //                     _input.alphanumeric({ allow: ',.' });
    //                     break;
    //             }

    //             if (settings.inputmask) $(_input).mask(settings.inputmask);

    //             if (settings.placeholder) $(_input).attr('placeholder', settings.placeholder);
    //         }

    //         var btn_cfm = $("<button class='btn btn-success btn-" + settings.btnsize + "' wid=" + wid + "><span class='mdi mdi-check'></span> " + settings.btnoklabel + ' </button>');
    //         var btn_cancel = $("<button class='btn btn-danger btn-" + settings.btnsize + "' wid=" + wid + "><span class='mdi mdi-close'></span> Cancelar </button>");

    //         var _footer = $("<div class='window-component-dialog-footer'></div>");
    //         _footer.append(btn_cfm);

    //         _.each(settings.custombtns, function (btn) {
    //             var cls = typeof btn.cls != 'undefined' ? btn.cls : 'default';
    //             var icon = typeof btn.icon != 'undefined' ? btn.icon : 'circle';
    //             var txt = typeof btn.txt != 'undefined' ? btn.txt : 'Button';
    //             var btn_custom = $("<button class='btn btn-" + cls + ' btn-' + settings.btnsize + "' wid=" + wid + "><span class='mdi mdi-" + icon + "'></span> " + txt + '</button>');

    //             if (typeof btn.callback === 'function')
    //                 btn_custom.click(function () {
    //                     btn.callback();
    //                 });

    //             _footer.append(btn_custom);
    //         });

    //         _footer.append(btn_cancel);

    //         dialog.append(dialog_head);
    //         dialog.append(_content);
    //         dialog.append(_footer);

    //         btn_cfm.click(function () {
    //             var wid = $(this).attr('wid');
    //             var r: any = settings.showinput ? $('#window-component-dialog-input-' + wid).val() : true;
    //             if (settings.inputminl > 0) {
    //                 if (r.length >= settings.inputminl) {
    //                     if (typeof callback === 'function') callback(r);

    //                     Core.WinManager.CloseDialog(wid);
    //                 } else {
    //                     Core.WinManager.Message(wid, 'Informe o ' + settings.inputnome, 'danger');
    //                 }
    //             } else {
    //                 if (typeof callback === 'function') callback(r);
    //                 Core.WinManager.CloseDialog(wid);
    //             }
    //         });

    //         btn_cancel.click(function () {
    //             Core.WinManager.CloseDialog(wid);
    //         });

    //         content.append(dialog);

    //         _window.keydown(function (e) {
    //             if (e.keyCode == 13 || e.charCode == 13) btn_cfm.click();
    //         });

    //         if (settings.showinput) _input.focus();
    //     },

    //     CloseDialog: function (wid) {
    //         var dialog = $('#window-component-dialog-' + wid);
    //         dialog.remove();

    //         var mask = $('#window-component-mask-' + wid);
    //         mask.remove();
    //     },

    //     Message: function (wid, message, kind) {
    //         kind = typeof kind !== 'undefined' ? kind : 'success'; // success, danger, warning -- bootstrap classes
    //         var _window: any = this.GetByWid(wid);
    //         var content = $('#window-component-content-' + _window.wid);
    //         var alert = $("<div class='alert alert-" + kind + "' style='position: absolute; display: none; box-shadow:0px 0px 3px #666; z-index: 2099; top: 50%; left: 50%; border-radius: 5px; max-width: 50%'>" + message + '</div>');
    //         var button = $("<button type='button' class='close' data-dismiss='alert' aria-label='Close' style='margin-left:6px; margin-top: -2px'><span aria-hidden='true'>&times;</span></button>");

    //         alert.append(button);
    //         alert.click(function () {
    //             alert.remove();
    //         });
    //         content.append(alert);

    //         switch (kind) {
    //             case 'success':
    //                 var icon = $("<span class='mdi mdi-check' style='margin-right: 10px; font-size: 18px;'></span>");
    //                 alert.prepend(icon);
    //                 break;

    //             case 'danger':
    //                 var icon = $("<span class='mdi mdi-alert' style='margin-right: 10px; font-size: 18px;'></span>");
    //                 alert.prepend(icon);
    //                 break;

    //             case 'warning':
    //                 var icon = $("<span class='mdi mdi-alert' style='margin-right: 10px; font-size: 18px;'></span>");
    //                 alert.prepend(icon);
    //                 break;
    //         }

    //         var aw = alert.outerWidth() / 2 + 15;
    //         var ah = alert.outerHeight() / 2;
    //         alert.css({ 'margin-left': '-' + aw + 'px', 'margin-top': '-' + ah + 'px' });
    //         alert.show();

    //         Core.WinManager.beep.play();
    //         window.setTimeout(function () {
    //             alert.remove();
    //         }, 5000);
    //     },

    //     GetByWid: function (wid) {
    //         for (var i in this._windows) {
    //             if (this._windows[i].wid == wid) return this._windows[i];
    //         }
    //     },
    // },
};

// -- INIT EVENT HANDLERS
$(() => {
    Core.Auth.init();
});
